import React, { useState } from 'react';
import { ModalOverlay } from '../Modal';
import { ModaPrivateForm } from './ModaPrivateForm';
import { ModaPrivateSuccessMessage } from './ModaPrivateSuccessMessage';
import './ModaPrivateRequestModal.scss';

enum Mode {
  Idle,
  Success
}

type Props = {
  show: boolean;
  onClose: () => void;
};

export const ModaPrivateRequestModal: React.FC<Props> = ({ show, onClose }) => {
  const [mode, setMode] = useState(Mode.Idle);

  return (
    <ModalOverlay show={show} onClose={onClose}>
      <div className="ModaPrivateRequestModal">
        {mode === Mode.Idle && (
          <ModaPrivateForm onClose={onClose} onSuccess={() => setMode(Mode.Success)} />
        )}
        {mode === Mode.Success && <ModaPrivateSuccessMessage onClose={onClose} />}
      </div>
    </ModalOverlay>
  );
};
